<script lang="ts">
  // Legt die Anordnung EINER Seite in den Kontext (lib/anordnung.svelte.ts)
  // und zeigt im Sortiermodus die Leiste darüber. Gerufen von PageHost
  // (Schreibtisch, je Tab) und von App.svelte (Telefon) -- die Seite
  // selbst tut nichts dafür.
  //
  // Die Leiste (AnordnenLeiste) steht sticky an der Oberkante der Fläche,
  // damit „Fertig" auch dann zu sehen ist, wenn die gezogene Karte weiter
  // unten liegt.
  import type { Snippet } from "svelte";

  import AnordnenLeiste from "./AnordnenLeiste.svelte";
  import { Anordnung, SEITE, setAnordnung } from "./anordnung.svelte";
  import { t } from "./i18n.svelte";

  interface Props {
    /** Muster der Route („/infra/cluster/:host_id"), nicht der Pfad */
    seite: string;
    children: Snippet;
  }
  let { seite, children }: Props = $props();

  const ordnung = new Anordnung(() => seite);
  setAnordnung(ordnung);

  const gruppe = $derived(ordnung.sortiert);
  const text = $derived(
    gruppe
      ? (ordnung.hinweis(gruppe) ??
          (gruppe === SEITE
            ? t("anordnung.hinweis.seite", "Karten ziehen, um sie neu anzuordnen")
            : t("anordnung.hinweis", "Ziehen, um neu anzuordnen")))
      : "",
  );
</script>

{#if gruppe}
  <AnordnenLeiste
    {text}
    angepasst={ordnung.angepasst(gruppe)}
    onzuruecksetzen={() => ordnung.zuruecksetzen(gruppe)}
    onfertig={() => ordnung.beende()}
    class="sticky z-30 mb-4"
    style="top: var(--tabellen-top, 3.5rem)"
  />
{/if}
{@render children()}
